import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Rejects values that contain only whitespace.
 *
 * `Validators.required` accepts "   ", which reaches Dataverse as a blank narrative field. This
 * validator deliberately stays silent on empty values so it can be applied on the Save Draft path,
 * where `required` is dropped but format rules are kept.
 */
export function notBlankValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const value = control.value;
    if (typeof value !== 'string' || value.length === 0) return null;
    return value.trim().length === 0 ? { notBlank: true } : null;
  };
}
